window.JRS = window.JRS || {};

(function(JRS) {
  'use strict';

  var EventBus = JRS.EventBus;
  var ConfigurationState = JRS.ConfigurationState;
  var LogoService = JRS.LogoService;
  var APPLICATION_METHODS = JRS.APPLICATION_METHODS;
  var LOGO_TYPES = JRS.LOGO_TYPES;
  var LOGO_TYPE_DISPLAY = JRS.LOGO_TYPE_DISPLAY;
  var generateUUID = JRS.generateUUID;

  var _isOpen = false;
  var _mode = 'new';
  var _positionsData = [];
  var _existingLogos = [];
  var _currentPositionIndex = 0;
  var _sameForAllActive = false;
  var _sameForAllGroupId = null;
  var _completedThisSession = false;
  var _boundListeners = [];
  var _scrollPosition = 0;
  var _currentStepName = 'choose';

  function open() {
    _mode = 'new';
    _completedThisSession = false;
    _prepareFromConfiguration(false, null);
    _showPopup();
    _goToEntryStep();
  }

  function openInEditMode(payload) {
    _mode = 'edit';
    _completedThisSession = false;
    _prepareFromConfiguration(true, payload || null);
    _showPopup();
    _goToStep('positions');
  }

  function close() {
    if (!_isOpen) return;
    _destroyListeners();
    _hidePopup();
    _unlockScroll();
    _isOpen = false;

    if (!_completedThisSession) {
      EventBus.emit('customization:cancelled', {});
    }
  }

  function isOpen() {
    return _isOpen;
  }

  function _goToEntryStep() {
    if (_hasBundleCategories()) {
      _goToStep('positions');
      return;
    }
    _goToStep('choose');
  }

  function _prepareFromConfiguration(prefill, payload) {
    _positionsData = [];
    _existingLogos = _parseExistingLogos();
    _currentPositionIndex = 0;
    _sameForAllActive = false;
    _sameForAllGroupId = null;

    if (payload && payload.positionData && Array.isArray(payload.positionData)) {
      _positionsData = _normalizeExternalPositions(payload.positionData);
    } else {
      _positionsData = _readPositionDataFromDOM();
    }

    if (prefill) {
      _prefillFromExistingCustomization();
    }
  }

  function _readPositionDataFromDOM() {
    var config = ConfigurationState.getConfiguration();
    var categories = config && config.categories ? config.categories : [];
    var loaded = [];

    if (categories.length > 1) {
      for (var categoryIndex = 0; categoryIndex < categories.length; categoryIndex++) {
        var categoryRows = _parsePositionScript(document.querySelector('[data-jrs-category-positions="' + String(categoryIndex) + '"]'));
        for (var i = 0; i < categoryRows.length; i++) {
          categoryRows[i].categoryIndex = categoryIndex;
          loaded.push(categoryRows[i]);
        }
      }
      if (loaded.length > 0) return loaded;
    }

    var globalRows = _parsePositionScript(document.querySelector('[data-jrs-position-definitions]'));
    for (var g = 0; g < globalRows.length; g++) {
      if (typeof globalRows[g].categoryIndex !== 'number') {
        globalRows[g].categoryIndex = 0;
      }
    }
    return globalRows;
  }

  function _parsePositionScript(scriptEl) {
    if (!scriptEl) return [];

    var parsed = [];
    try {
      parsed = JSON.parse(scriptEl.textContent || '[]');
    } catch (error) {
      console.error('[Customizer] Failed parsing position JSON', error);
      return [];
    }

    if (!Array.isArray(parsed)) return [];

    var out = [];
    for (var i = 0; i < parsed.length; i++) {
      var row = parsed[i] || {};
      out.push({
        name: String(row.name || ''),
        handle: String(row.handle || _toHandle(row.name || '')),
        categoryIndex: Number(row.categoryIndex || 0),
        embroideryVariantId: Number(row.embroideryVariantId || 0),
        printVariantId: Number(row.printVariantId || 0),
        embroideryPrice: Number(row.embroideryPrice || 0),
        printPrice: Number(row.printPrice || 0),
        selected: false,
        applicationMethod: APPLICATION_METHODS.EMBROIDERY,
        logoType: LOGO_TYPES.UPLOAD,
        logo: null,
        note: ''
      });
    }

    return out;
  }

  function _normalizeExternalPositions(rows) {
    var out = [];
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i] || {};
      out.push({
        name: String(row.name || row.positionName || ''),
        handle: String(row.handle || _toHandle(row.name || row.positionName || '')),
        categoryIndex: Number(row.categoryIndex || 0),
        embroideryVariantId: Number(row.embroideryVariantId || 0),
        printVariantId: Number(row.printVariantId || 0),
        embroideryPrice: Number(row.embroideryPrice || row.price || 0),
        printPrice: Number(row.printPrice || row.price || 0),
        selected: false,
        applicationMethod: APPLICATION_METHODS.EMBROIDERY,
        logoType: LOGO_TYPES.UPLOAD,
        logo: null,
        note: ''
      });
    }
    return out;
  }

  function _parseExistingLogos() {
    var scriptEl = document.querySelector('[data-jrs-existing-logos]');
    if (!scriptEl) return [];

    try {
      var parsed = JSON.parse(scriptEl.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.warn('[Customizer] Failed parsing existing logos JSON', error);
      return [];
    }
  }

  function _prefillFromExistingCustomization() {
    var config = ConfigurationState.getConfiguration();
    var positions = config && config.customization && config.customization.positions
      ? config.customization.positions
      : [];

    if (!positions || positions.length === 0) return;

    for (var i = 0; i < positions.length; i++) {
      var source = positions[i] || {};
      var target = _findPosition(source.positionName, source.categoryIndex);
      if (!target) {
        target = {
          name: String(source.positionName || ''),
          handle: _toHandle(source.positionName || ''),
          categoryIndex: Number(source.categoryIndex || 0),
          embroideryVariantId: source.applicationMethod === APPLICATION_METHODS.EMBROIDERY ? Number(source.positionVariantId || 0) : 0,
          printVariantId: source.applicationMethod === APPLICATION_METHODS.PRINT ? Number(source.positionVariantId || 0) : 0,
          embroideryPrice: 0,
          printPrice: 0,
          selected: true,
          applicationMethod: source.applicationMethod || APPLICATION_METHODS.EMBROIDERY,
          logoType: source.logo && source.logo.type ? source.logo.type : LOGO_TYPES.UPLOAD,
          logo: source.logo ? _clone(source.logo) : null,
          note: source.logo && source.logo.note ? String(source.logo.note) : ''
        };
        _positionsData.push(target);
      } else {
        target.selected = true;
        target.applicationMethod = source.applicationMethod || APPLICATION_METHODS.EMBROIDERY;
        target.logoType = source.logo && source.logo.type ? source.logo.type : LOGO_TYPES.UPLOAD;
        target.logo = source.logo ? _clone(source.logo) : null;
        target.note = source.logo && source.logo.note ? String(source.logo.note) : '';
      }
    }

    if (positions.length > 0) {
      _sameForAllGroupId = positions[0].sourceLogoGroupId || null;
      _sameForAllActive = !!_sameForAllGroupId;
    }
  }

  function _showPopup() {
    var popup = _getPopup();
    if (!popup) throw new Error('Customizer: Missing [data-jrs-customizer-popup]');
    popup.style.display = 'block';
    popup.setAttribute('aria-hidden', 'false');
    _lockScroll();
    _isOpen = true;
    _bindGlobalPopupListeners();
  }

  function _hidePopup() {
    var popup = _getPopup();
    if (!popup) return;
    popup.style.display = 'none';
    popup.setAttribute('aria-hidden', 'true');
  }

  function _bindGlobalPopupListeners() {
    var closeEls = document.querySelectorAll('[data-jrs-customizer-close]');
    for (var i = 0; i < closeEls.length; i++) {
      _bindListener(closeEls[i], 'click', function(e) {
        e.preventDefault();
        close();
      });
    }

    _bindListener(document, 'keydown', function(e) {
      if (e.key === 'Escape') {
        close();
      }
    });
  }

  function _goToStep(stepName) {
    _currentStepName = stepName;
    _destroyStepListeners();
    _showStep(stepName);
    _setHeaderForStep(stepName);
    _setStepIndicator(stepName);
    _renderStep(stepName);
    _updateFooter(stepName);
  }

  function _renderStep(stepName) {
    if (stepName === 'choose') return _renderChooseStep();
    if (stepName === 'positions') return _renderPositionsStep();
    if (stepName === 'logoType') return _renderLogoTypeStep();
    if (stepName === 'upload') return _renderUploadStep();
    if (stepName === 'existing') return _renderExistingStep();
    if (stepName === 'text') return _renderTextStep();
    if (stepName === 'confirm') return _renderConfirmStep();
  }

  function _showStep(stepName) {
    var steps = document.querySelectorAll('[data-jrs-customizer-step]');
    for (var i = 0; i < steps.length; i++) {
      var isMatch = steps[i].getAttribute('data-jrs-customizer-step') === stepName;
      steps[i].style.display = isMatch ? '' : 'none';
    }
  }

  function _setHeaderForStep(stepName) {
    var titleEl = document.querySelector('[data-jrs-customizer-title]');
    if (!titleEl) return;

    if (stepName === 'choose') titleEl.textContent = 'Customise Your Order';
    if (stepName === 'positions') titleEl.textContent = 'Select Positions';
    if (stepName === 'logoType') titleEl.textContent = 'Choose Logo Type';
    if (stepName === 'upload') titleEl.textContent = 'Upload Your Logo';
    if (stepName === 'existing') titleEl.textContent = 'Use Existing Logo';
    if (stepName === 'text') titleEl.textContent = 'Create Text Logo';
    if (stepName === 'confirm') titleEl.textContent = 'Review Your Customisation';
  }

  function _setStepIndicator(stepName) {
    var indicator = document.querySelector('[data-jrs-customizer-step-indicator]');
    if (!indicator) return;

    var map = {
      choose: 'Step 1 of 5',
      positions: 'Step 2 of 5',
      logoType: 'Step 3 of 5',
      upload: 'Step 4 of 5',
      existing: 'Step 4 of 5',
      text: 'Step 4 of 5',
      confirm: 'Step 5 of 5'
    };
    indicator.textContent = map[stepName] || '';
  }

  function _updateFooter(stepName) {
    var backBtn = document.querySelector('[data-jrs-customizer-back]');
    if (!backBtn) return;

    if (stepName === 'choose' && _mode === 'new') {
      backBtn.style.display = 'none';
      return;
    }

    backBtn.style.display = '';
    _bindListener(backBtn, 'click', function() {
      _goBack();
    });
  }

  function _renderChooseStep() {
    var yesBtn = document.querySelector('[data-jrs-customizer-yes]');
    var noBtn = document.querySelector('[data-jrs-customizer-no]');

    if (yesBtn) {
      _bindListener(yesBtn, 'click', function() {
        EventBus.emit('customizer:stepCompleted', { stepName: 'choose_yes' });
        _goToStep('positions');
      });
    }

    if (noBtn) {
      _bindListener(noBtn, 'click', function() {
        ConfigurationState.clearCustomization();
        close();
      });
    }
  }

  function _renderPositionsStep() {
    var listEl = document.querySelector('[data-jrs-positions-list]');
    var sameForAllContainer = document.querySelector('[data-jrs-same-for-all-container]');
    var sameForAllInput = document.querySelector('[data-jrs-same-for-all]');
    var methodChoice = document.querySelector('[data-jrs-method-choice]');
    var continueBtn = _visibleContinueButton();

    if (!listEl) return;

    listEl.innerHTML = _buildPositionsMarkup();
    _clearAllErrors();

    if (sameForAllContainer) {
      if (_hasBundleCategories()) {
        sameForAllContainer.style.display = '';
        if (sameForAllInput) sameForAllInput.checked = _sameForAllActive;
      } else {
        sameForAllContainer.style.display = 'none';
      }
    }

    _toggleMethodChoice();
    if (methodChoice) {
      methodChoice.style.display = _selectedPositions().length > 0 ? '' : 'none';
    }

    _syncContinueEnabled();

    _bindListener(listEl, 'change', function(e) {
      var checkbox = e.target && e.target.closest ? e.target.closest('[data-jrs-position-checkbox]') : null;
      if (!checkbox) return;
      var index = Number(checkbox.getAttribute('data-jrs-position-index') || -1);
      if (index < 0 || !_positionsData[index]) return;
      _positionsData[index].selected = !!checkbox.checked;
      _toggleMethodChoice();
      _syncContinueEnabled();
    });

    if (sameForAllInput) {
      _bindListener(sameForAllInput, 'change', function() {
        _sameForAllActive = !!sameForAllInput.checked;
        _sameForAllGroupId = _sameForAllActive ? _uuid() : null;
      });
    }

    if (continueBtn) {
      _bindListener(continueBtn, 'click', function() {
        if (_selectedPositions().length === 0) {
          _setVisibleError('Please select at least one position.');
          return;
        }
        _currentPositionIndex = 0;
        EventBus.emit('customizer:stepCompleted', { stepName: 'positions_selected' });
        _goToStep('logoType');
      });
    }
  }

  function _renderLogoTypeStep() {
    var selected = _selectedPositions();
    if (selected.length === 0) {
      _goToStep('positions');
      return;
    }

    var target = selected[_sameForAllActive ? 0 : _currentPositionIndex];
    var labelEl = document.querySelector('[data-jrs-logo-type-position-label]');
    if (labelEl) {
      labelEl.textContent = _sameForAllActive
        ? 'This will apply to all selected positions.'
        : 'Position: ' + target.name;
    }

    var logoTypeBtns = document.querySelectorAll('[data-jrs-logo-type]');
    for (var i = 0; i < logoTypeBtns.length; i++) {
      _bindListener(logoTypeBtns[i], 'click', function(e) {
        var value = e.currentTarget.getAttribute('data-jrs-logo-type');
        _applyLogoTypeToSelected(value);
        EventBus.emit('customizer:stepCompleted', {
          stepName: 'logo_type_selected',
          logoType: value
        });
        _goToStep(value === LOGO_TYPES.EXISTING ? 'existing' : value);
      });
    }
  }

  function _renderUploadStep() {
    var selected = _selectedPositions();
    if (selected.length === 0) {
      _goToStep('positions');
      return;
    }

    var target = selected[_sameForAllActive ? 0 : _currentPositionIndex];
    target.logoType = LOGO_TYPES.UPLOAD;

    var titleEl = document.querySelector('[data-jrs-upload-title]');
    if (titleEl) {
      titleEl.textContent = _sameForAllActive ? 'Upload Your Logo (All Positions)' : 'Upload Your Logo';
    }

    var positionLabel = document.querySelector('[data-jrs-upload-position-label]');
    if (positionLabel) {
      positionLabel.textContent = _sameForAllActive ? 'All selected positions' : 'Position: ' + target.name;
    }

    var dropzone = document.querySelector('[data-jrs-upload-dropzone]');
    var input = document.querySelector('[data-jrs-upload-input]');
    var browseBtn = document.querySelector('[data-jrs-upload-browse]');
    var progressWrap = document.querySelector('[data-jrs-upload-progress]');
    var progressFill = document.querySelector('[data-jrs-upload-progress-fill]');
    var progressText = document.querySelector('[data-jrs-upload-progress-text]');
    var previewWrap = document.querySelector('[data-jrs-upload-preview]');
    var previewImg = document.querySelector('[data-jrs-upload-preview-img]');
    var removeBtn = document.querySelector('[data-jrs-upload-remove]');
    var errorEl = document.querySelector('[data-jrs-upload-error]');
    var notesEl = document.querySelector('[data-jrs-upload-notes]');
    var continueBtn = _visibleContinueButton();

    if (notesEl) {
      notesEl.value = target.note || '';
      _bindListener(notesEl, 'input', function() {
        target.note = String(notesEl.value || '');
        if (target.logo) target.logo.note = target.note;
      });
    }

    function clearUploadError() {
      if (!errorEl) return;
      errorEl.style.display = 'none';
      errorEl.textContent = '';
    }

    function setUploadError(message) {
      if (!errorEl) return;
      errorEl.style.display = '';
      errorEl.textContent = String(message || 'Upload failed.');
    }

    function resetUploadUI() {
      if (previewWrap) previewWrap.style.display = 'none';
      if (previewImg) previewImg.setAttribute('src', '');
      if (progressWrap) progressWrap.style.display = 'none';
      if (progressFill) progressFill.style.width = '0%';
      if (progressText) progressText.textContent = '0%';
      clearUploadError();
      target.logo = null;
      _syncContinueEnabled();
    }

    function handleUpload(file) {
      var validation = LogoService.validateFile(file);
      if (!validation.valid) {
        setUploadError(validation.error || 'Invalid file');
        return;
      }

      clearUploadError();
      if (progressWrap) progressWrap.style.display = '';

      LogoService.uploadFile(file, function(percent) {
        var pct = Math.max(0, Math.min(100, Number(percent || 0)));
        if (progressFill) progressFill.style.width = String(pct) + '%';
        if (progressText) progressText.textContent = String(pct) + '%';
      }).then(function(result) {
        target.logo = {
          type: LOGO_TYPES.UPLOAD,
          logoId: String(result.logoId || _uuid()),
          url: String(result.url || ''),
          filename: String(result.filename || file.name || ''),
          text: null,
          note: target.note || ''
        };

        if (previewWrap) previewWrap.style.display = '';
        if (previewImg) previewImg.setAttribute('src', target.logo.url);
        if (progressWrap) progressWrap.style.display = 'none';
        EventBus.emit('customizer:logoUploaded', {
          logoId: target.logo.logoId,
          positionName: target.name,
          fileSize: Number(file.size || 0)
        });
        _syncContinueEnabled();
      }).catch(function(error) {
        if (progressWrap) progressWrap.style.display = 'none';
        setUploadError(error && error.message ? error.message : 'Upload failed.');
        _syncContinueEnabled();
      });
    }

    if (input) {
      _bindListener(input, 'change', function() {
        var file = input.files && input.files[0] ? input.files[0] : null;
        if (!file) return;
        handleUpload(file);
      });
    }

    if (browseBtn && input) {
      _bindListener(browseBtn, 'click', function() {
        input.click();
      });
    }

    if (removeBtn) {
      _bindListener(removeBtn, 'click', function() {
        resetUploadUI();
      });
    }

    if (dropzone) {
      _bindListener(dropzone, 'dragover', function(e) {
        e.preventDefault();
        dropzone.classList.add('is-dragover');
      });
      _bindListener(dropzone, 'dragleave', function() {
        dropzone.classList.remove('is-dragover');
      });
      _bindListener(dropzone, 'drop', function(e) {
        e.preventDefault();
        dropzone.classList.remove('is-dragover');
        var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0] ? e.dataTransfer.files[0] : null;
        if (!file) return;
        handleUpload(file);
      });
    }

    if (continueBtn) {
      _bindListener(continueBtn, 'click', function() {
        if (!_isCurrentLogoStepComplete(target)) {
          _setVisibleError('Please upload your logo before continuing.');
          return;
        }
        _clearAllErrors();
        _applyCurrentLogoToTargets(target);
        EventBus.emit('customizer:stepCompleted', {
          stepName: 'upload_completed',
          positionName: target.name,
          logoType: target.logoType
        });
        _nextAfterLogoInput();
      });
    }

    _syncContinueEnabled();
  }

  function _renderExistingStep() {
    var selected = _selectedPositions();
    if (selected.length === 0) {
      _goToStep('positions');
      return;
    }

    var target = selected[_sameForAllActive ? 0 : _currentPositionIndex];
    target.logoType = LOGO_TYPES.EXISTING;

    var labelEl = document.querySelector('[data-jrs-existing-position-label]');
    if (labelEl) {
      labelEl.textContent = _sameForAllActive ? 'All selected positions' : 'Position: ' + target.name;
    }

    var notesEl = document.querySelector('[data-jrs-existing-notes]');
    var continueBtn = _visibleContinueButton();
    if (notesEl) {
      notesEl.value = target.note || '';
      _bindListener(notesEl, 'input', function() {
        target.note = String(notesEl.value || '');
        target.logo = {
          type: LOGO_TYPES.EXISTING,
          logoId: _pickExistingLogoId(target.note),
          url: null,
          filename: null,
          text: null,
          note: target.note
        };
        _syncContinueEnabled();
      });
    }

    if (continueBtn) {
      _bindListener(continueBtn, 'click', function() {
        if (!_isCurrentLogoStepComplete(target)) {
          _setVisibleError('Please describe your existing logo.');
          return;
        }
        _clearAllErrors();
        _applyCurrentLogoToTargets(target);
        EventBus.emit('customizer:stepCompleted', {
          stepName: 'existing_completed',
          positionName: target.name,
          logoType: target.logoType
        });
        _nextAfterLogoInput();
      });
    }

    _syncContinueEnabled();
  }

  function _renderTextStep() {
    var selected = _selectedPositions();
    if (selected.length === 0) {
      _goToStep('positions');
      return;
    }

    var target = selected[_sameForAllActive ? 0 : _currentPositionIndex];
    target.logoType = LOGO_TYPES.TEXT;

    var labelEl = document.querySelector('[data-jrs-text-position-label]');
    if (labelEl) {
      labelEl.textContent = _sameForAllActive ? 'All selected positions' : 'Position: ' + target.name;
    }

    var textLogo = target.logo && target.logo.type === LOGO_TYPES.TEXT
      ? target.logo
      : {
          type: LOGO_TYPES.TEXT,
          logoId: _uuid(),
          url: null,
          filename: null,
          text: {
            lines: ['', '', '', ''],
            colour: 'Black',
            font: 'Standard'
          },
          note: ''
        };

    target.logo = textLogo;

    var lineInputs = document.querySelectorAll('[data-jrs-text-line]');
    var extraLines = document.querySelectorAll('[data-jrs-text-line-extra]');
    var addLineBtn = document.querySelector('[data-jrs-text-add-line]');
    var fontEl = document.querySelector('[data-jrs-text-font]');
    var colourEl = document.querySelector('[data-jrs-text-colour]');
    var notesEl = document.querySelector('[data-jrs-text-notes]');
    var previewContent = document.querySelector('[data-jrs-text-preview-content]');
    var continueBtn = _visibleContinueButton();

    var lines = textLogo.text && textLogo.text.lines ? textLogo.text.lines.slice(0, 4) : ['', '', '', ''];
    while (lines.length < 4) lines.push('');

    for (var i = 0; i < lineInputs.length; i++) {
      var idx = Number(lineInputs[i].getAttribute('data-jrs-text-line') || 0);
      lineInputs[i].value = lines[idx] || '';
    }

    if (fontEl) fontEl.value = textLogo.text && textLogo.text.font ? textLogo.text.font : 'Standard';
    if (colourEl) colourEl.value = textLogo.text && textLogo.text.colour ? textLogo.text.colour : 'Black';
    if (notesEl) notesEl.value = target.note || '';

    function syncTextState() {
      var newLines = ['', '', '', ''];
      for (var li = 0; li < lineInputs.length; li++) {
        var lineIndex = Number(lineInputs[li].getAttribute('data-jrs-text-line') || 0);
        newLines[lineIndex] = String(lineInputs[li].value || '');
      }

      target.note = notesEl ? String(notesEl.value || '') : '';
      target.logo = {
        type: LOGO_TYPES.TEXT,
        logoId: textLogo.logoId || _uuid(),
        url: null,
        filename: null,
        text: {
          lines: newLines,
          colour: colourEl ? String(colourEl.value || 'Black') : 'Black',
          font: fontEl ? String(fontEl.value || 'Standard') : 'Standard'
        },
        note: target.note
      };

      if (previewContent) {
        previewContent.style.fontFamily = target.logo.text.font;
        previewContent.textContent = newLines.filter(function(line) {
          return String(line || '').trim() !== '';
        }).join(' / ');
      }

      _syncContinueEnabled();
    }

    for (var li2 = 0; li2 < lineInputs.length; li2++) {
      _bindListener(lineInputs[li2], 'input', syncTextState);
    }
    if (fontEl) _bindListener(fontEl, 'change', syncTextState);
    if (colourEl) _bindListener(colourEl, 'change', syncTextState);
    if (notesEl) _bindListener(notesEl, 'input', syncTextState);

    if (addLineBtn) {
      _bindListener(addLineBtn, 'click', function() {
        for (var x = 0; x < extraLines.length; x++) {
          if (extraLines[x].style.display === 'none') {
            extraLines[x].style.display = '';
            break;
          }
        }
      });
    }

    if (continueBtn) {
      _bindListener(continueBtn, 'click', function() {
        if (!_isCurrentLogoStepComplete(target)) {
          _setVisibleError('Please add at least one text line.');
          return;
        }
        _clearAllErrors();
        _applyCurrentLogoToTargets(target);
        EventBus.emit('customizer:stepCompleted', {
          stepName: 'text_completed',
          positionName: target.name,
          logoType: target.logoType
        });
        _nextAfterLogoInput();
      });
    }

    syncTextState();
  }

  function _renderConfirmStep() {
    var summaryEl = document.querySelector('[data-jrs-customizer-summary]');
    var finishBtn = document.querySelector('[data-jrs-customizer-finish]');
    var editBtn = document.querySelector('[data-jrs-customizer-edit]');

    if (summaryEl) {
      summaryEl.innerHTML = _buildSummaryMarkup();
    }

    if (finishBtn) {
      _bindListener(finishBtn, 'click', function() {
        _commitToState();
      });
    }

    if (editBtn) {
      _bindListener(editBtn, 'click', function() {
        _goToStep('positions');
      });
    }
  }

  function _goBack() {
    if (_currentStepName === 'confirm') {
      if (_selectedPositions().length > 0) {
        _currentPositionIndex = Math.max(0, _selectedPositions().length - 1);
      }
      _goToStep(_selectedLogoTypeToStepName());
      return;
    }

    if (_currentStepName === 'upload' || _currentStepName === 'existing' || _currentStepName === 'text') {
      _goToStep('logoType');
      return;
    }

    if (_currentStepName === 'logoType') {
      _goToStep('positions');
      return;
    }

    if (_currentStepName === 'positions') {
      if (_mode === 'new' && !_hasBundleCategories()) {
        _goToStep('choose');
      } else {
        close();
      }
      return;
    }

    close();
  }

  function _nextAfterLogoInput() {
    var selected = _selectedPositions();
    if (_sameForAllActive || selected.length <= 1) {
      _goToStep('confirm');
      return;
    }
    if (_currentPositionIndex < selected.length - 1) {
      _currentPositionIndex += 1;
      _goToStep('logoType');
      return;
    }
    _goToStep('confirm');
  }

  function _commitToState() {
    var selected = _selectedPositions();
    var positions = [];

    for (var i = 0; i < selected.length; i++) {
      var row = selected[i];
      var variantId = row.applicationMethod === APPLICATION_METHODS.PRINT
        ? Number(row.printVariantId || 0)
        : Number(row.embroideryVariantId || 0);

      if (variantId <= 0) {
        console.error('[Customizer] Missing variant id for position', row.name);
        continue;
      }

      var normalizedLogo = _normalizedLogoForCommit(row);
      if (!normalizedLogo || !normalizedLogo.logoId) {
        console.error('[Customizer] Missing logo for position', row.name);
        continue;
      }

      positions.push({
        id: _uuid(),
        positionName: row.name,
        positionVariantId: variantId,
        applicationMethod: row.applicationMethod,
        categoryIndex: Number(row.categoryIndex || 0),
        sourceLogoGroupId: _sameForAllActive ? _sameForAllGroupId : null,
        logo: normalizedLogo
      });
    }

    ConfigurationState.setPositions(positions);
    var cfg = ConfigurationState.getConfiguration();
    _completedThisSession = true;
    EventBus.emit('customization:complete', { instanceId: cfg.instanceId });
    close();
  }

  function _normalizedLogoForCommit(position) {
    if (!position || !position.logo) return null;

    if (position.logoType === LOGO_TYPES.TEXT) {
      var text = position.logo.text || {};
      var lines = Array.isArray(text.lines) ? text.lines.slice(0, 4) : ['', '', '', ''];
      while (lines.length < 4) lines.push('');
      return {
        type: LOGO_TYPES.TEXT,
        logoId: String(position.logo.logoId || _uuid()),
        url: null,
        filename: null,
        text: {
          lines: lines,
          colour: String(text.colour || 'Black'),
          font: String(text.font || 'Standard')
        },
        note: String(position.note || position.logo.note || '')
      };
    }

    if (position.logoType === LOGO_TYPES.EXISTING) {
      return {
        type: LOGO_TYPES.EXISTING,
        logoId: String(position.logo.logoId || _uuid()),
        url: null,
        filename: null,
        text: null,
        note: String(position.note || position.logo.note || '')
      };
    }

    return {
      type: LOGO_TYPES.UPLOAD,
      logoId: String(position.logo.logoId || _uuid()),
      url: position.logo.url ? String(position.logo.url) : null,
      filename: position.logo.filename ? String(position.logo.filename) : null,
      text: null,
      note: String(position.note || position.logo.note || '')
    };
  }

  function _toggleMethodChoice() {
    var wrapper = document.querySelector('[data-jrs-method-choice]');
    if (!wrapper) return;
    var selectedCount = _selectedPositions().length;
    wrapper.style.display = selectedCount > 0 ? '' : 'none';

    if (selectedCount > 0) {
      var radios = wrapper.querySelectorAll('input[name="jrs-method"]');
      for (var i = 0; i < radios.length; i++) {
        _bindListener(radios[i], 'change', function(e) {
          var value = String(e.target.value || APPLICATION_METHODS.EMBROIDERY);
          _applyMethodToSelected(value);
        });
      }
    }
  }

  function _applyMethodToSelected(method) {
    var selected = _selectedPositions();
    var normalized = method === APPLICATION_METHODS.PRINT
      ? APPLICATION_METHODS.PRINT
      : APPLICATION_METHODS.EMBROIDERY;
    for (var i = 0; i < selected.length; i++) {
      selected[i].applicationMethod = normalized;
    }
  }

  function _applyLogoTypeToSelected(type) {
    var selected = _selectedPositions();
    for (var i = 0; i < selected.length; i++) {
      selected[i].logoType = type;
      if (selected[i].logo) {
        selected[i].logo.type = type;
      }
    }
  }

  function _applyCurrentLogoToTargets(source) {
    if (!_sameForAllActive) return;
    var selected = _selectedPositions();
    for (var i = 0; i < selected.length; i++) {
      selected[i].applicationMethod = source.applicationMethod;
      selected[i].logoType = source.logoType;
      selected[i].logo = _clone(source.logo);
      selected[i].note = source.note;
    }
  }

  function _syncContinueEnabled() {
    var btn = _visibleContinueButton();
    if (!btn) return;

    if (_currentStepName === 'positions') {
      btn.disabled = _selectedPositions().length === 0;
      return;
    }

    if (_currentStepName === 'upload' || _currentStepName === 'existing' || _currentStepName === 'text') {
      var selected = _selectedPositions();
      var target = selected[_sameForAllActive ? 0 : _currentPositionIndex];
      btn.disabled = !_isCurrentLogoStepComplete(target);
      return;
    }

    btn.disabled = false;
  }

  function _isCurrentLogoStepComplete(position) {
    if (!position) return false;
    if (position.logoType === LOGO_TYPES.UPLOAD) {
      return !!(position.logo && position.logo.url);
    }
    if (position.logoType === LOGO_TYPES.EXISTING) {
      return String(position.note || '').trim().length > 0;
    }
    if (position.logoType === LOGO_TYPES.TEXT) {
      if (!position.logo || !position.logo.text || !Array.isArray(position.logo.text.lines)) return false;
      for (var i = 0; i < position.logo.text.lines.length; i++) {
        if (String(position.logo.text.lines[i] || '').trim().length > 0) return true;
      }
      return false;
    }
    return false;
  }

  function _buildPositionsMarkup() {
    var grouped = _groupByCategory();
    var categoryKeys = Object.keys(grouped);
    var html = '';

    for (var c = 0; c < categoryKeys.length; c++) {
      var key = categoryKeys[c];
      var category = grouped[key];
      html += '<div class="jrs-customizer__category-group">';
      html += '<h4 class="jrs-customizer__category-title">' + _escapeHTML(category.name) + '</h4>';
      for (var i = 0; i < category.positions.length; i++) {
        var pos = category.positions[i];
        html += '<label class="jrs-customizer__position-row">';
        html += '<input type="checkbox" data-jrs-position-checkbox data-jrs-position-index="' + String(pos._index) + '"' + (pos.selected ? ' checked' : '') + '>';
        html += '<span class="jrs-customizer__position-name">' + _escapeHTML(pos.name) + '</span>';
        html += '<span class="jrs-customizer__position-prices">Emb ' + _formatMoney(pos.embroideryPrice) + ' / Print ' + _formatMoney(pos.printPrice) + '</span>';
        html += '</label>';
      }
      html += '</div>';
    }

    return html;
  }

  function _buildSummaryMarkup() {
    var selected = _selectedPositions();
    var html = '';
    for (var i = 0; i < selected.length; i++) {
      var pos = selected[i];
      html += '<div class="jrs-customizer__summary-row">';
      html += '<strong>' + _escapeHTML(pos.name) + '</strong>';
      html += '<div>Method: ' + _escapeHTML(pos.applicationMethod || '') + '</div>';
      html += '<div>Logo type: ' + _escapeHTML(_displayLogoType(pos.logoType)) + '</div>';
      if (pos.logoType === LOGO_TYPES.UPLOAD && pos.logo && pos.logo.filename) {
        html += '<div>File: ' + _escapeHTML(pos.logo.filename) + '</div>';
      }
      if (pos.logoType === LOGO_TYPES.EXISTING) {
        html += '<div>Reference: ' + _escapeHTML(pos.note || '') + '</div>';
      }
      if (pos.logoType === LOGO_TYPES.TEXT && pos.logo && pos.logo.text && pos.logo.text.lines) {
        html += '<div>Text: ' + _escapeHTML(pos.logo.text.lines.join(' / ')) + '</div>';
      }
      html += '</div>';
    }
    return html;
  }

  function _groupByCategory() {
    var cfg = ConfigurationState.getConfiguration();
    var categoryNames = {};
    if (cfg && cfg.categories) {
      for (var c = 0; c < cfg.categories.length; c++) {
        categoryNames[String(c)] = String(cfg.categories[c].name || ('Category ' + (c + 1)));
      }
    }

    var grouped = {};
    for (var i = 0; i < _positionsData.length; i++) {
      var key = String(Number(_positionsData[i].categoryIndex || 0));
      if (!grouped[key]) {
        grouped[key] = {
          name: categoryNames[key] || ('Category ' + (Number(key) + 1)),
          positions: []
        };
      }
      var copy = _clone(_positionsData[i]);
      copy._index = i;
      grouped[key].positions.push(copy);
    }
    return grouped;
  }

  function _selectedPositions() {
    var out = [];
    for (var i = 0; i < _positionsData.length; i++) {
      if (_positionsData[i].selected) out.push(_positionsData[i]);
    }
    return out;
  }

  function _findPosition(name, categoryIndex) {
    for (var i = 0; i < _positionsData.length; i++) {
      if (
        String(_positionsData[i].name) === String(name || '') &&
        Number(_positionsData[i].categoryIndex || 0) === Number(categoryIndex || 0)
      ) {
        return _positionsData[i];
      }
    }
    return null;
  }

  function _hasBundleCategories() {
    var seen = {};
    for (var i = 0; i < _positionsData.length; i++) {
      seen[String(_positionsData[i].categoryIndex || 0)] = true;
    }
    return Object.keys(seen).length > 1;
  }

  function _selectedLogoTypeToStepName() {
    var selected = _selectedPositions();
    var target = selected[_sameForAllActive ? 0 : _currentPositionIndex];
    if (!target) return 'logoType';
    if (target.logoType === LOGO_TYPES.EXISTING) return 'existing';
    if (target.logoType === LOGO_TYPES.TEXT) return 'text';
    return 'upload';
  }

  function _visibleContinueButton() {
    var step = document.querySelector('[data-jrs-customizer-step="' + _currentStepName + '"]');
    if (!step) return null;
    return step.querySelector('[data-jrs-customizer-continue]');
  }

  function _setVisibleError(message) {
    _clearAllErrors();
    var uploadError = document.querySelector('[data-jrs-upload-error]');
    if (_currentStepName === 'upload' && uploadError) {
      uploadError.style.display = '';
      uploadError.textContent = String(message || '');
      return;
    }
    var step = document.querySelector('[data-jrs-customizer-step="' + _currentStepName + '"]');
    if (!step) return;
    var fallback = step.querySelector('[role="alert"]');
    if (fallback) {
      fallback.style.display = '';
      fallback.textContent = String(message || '');
    }
  }

  function _clearAllErrors() {
    var alerts = document.querySelectorAll('[role="alert"]');
    for (var i = 0; i < alerts.length; i++) {
      alerts[i].textContent = '';
      if (alerts[i].hasAttribute('style')) {
        alerts[i].style.display = 'none';
      }
    }
  }

  function _pickExistingLogoId(note) {
    if (!_existingLogos.length) return _uuid();
    var normalized = String(note || '').toLowerCase();
    for (var i = 0; i < _existingLogos.length; i++) {
      var candidate = _existingLogos[i] || {};
      var candidateText = (String(candidate.name || '') + ' ' + String(candidate.reference || '')).toLowerCase();
      if (candidateText && normalized && candidateText.indexOf(normalized) !== -1) {
        return String(candidate.id || _uuid());
      }
    }
    return String((_existingLogos[0] && _existingLogos[0].id) || _uuid());
  }

  function _bindListener(el, event, handler) {
    if (!el || !event || !handler) return;
    el.addEventListener(event, handler);
    _boundListeners.push({ el: el, event: event, handler: handler });
  }

  function _destroyListeners() {
    for (var i = 0; i < _boundListeners.length; i++) {
      var item = _boundListeners[i];
      if (!item || !item.el) continue;
      item.el.removeEventListener(item.event, item.handler);
    }
    _boundListeners = [];
  }

  function _destroyStepListeners() {
    _destroyListeners();
    _bindGlobalPopupListeners();
  }

  function _lockScroll() {
    _scrollPosition = window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + _scrollPosition + 'px';
    document.body.style.width = '100%';
  }

  function _unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, _scrollPosition || 0);
  }

  function _getPopup() {
    return document.querySelector('[data-jrs-customizer-popup]');
  }

  function _uuid() {
    if (typeof generateUUID === 'function') return generateUUID();
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0;
      var v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  function _toHandle(str) {
    return String(str || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function _clone(obj) {
    try {
      return JSON.parse(JSON.stringify(obj));
    } catch (error) {
      void error;
      return obj;
    }
  }

  function _formatMoney(pence) {
    var value = Number(pence || 0) / 100;
    return '£' + value.toFixed(2);
  }

  function _displayLogoType(type) {
    if (type === LOGO_TYPES.UPLOAD) return LOGO_TYPE_DISPLAY.UPLOAD;
    if (type === LOGO_TYPES.EXISTING) return LOGO_TYPE_DISPLAY.EXISTING;
    if (type === LOGO_TYPES.TEXT) return LOGO_TYPE_DISPLAY.TEXT;
    return '';
  }

  function _escapeHTML(input) {
    return String(input || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  JRS.Customizer = {
    open: open,
    openInEditMode: openInEditMode,
    close: close,
    isOpen: isOpen
  };
})(window.JRS);
